import gql from "../gql";
import Learning from "../fragments/Learning";
export default gql `
  mutation favorite($name: String!, $type: LearningKind!) {
    markAsFavorite(input: { learning: { name: $name, type: $type } }) {
      __typename
      learning {
        ...LearningSummaryOnDetail
      }
    }
  }
  fragment LearningSummaryOnDetail on LearningSummary {
    favorite
    description
    ...Learning
  }
  ${Learning}
`;
